/* Camo & Country
   Storefront behaviour. The basket is Shopify's cart, reached over the AJAX
   Cart API, so this file asks for changes and re-renders what comes back
   rather than keeping its own copy of anything. */
(function(){
  'use strict';

  var R = window.CC_ROUTES || {};

  function money(cents){
    var f = window.CC_MONEY_FORMAT || '£{{amount}}';
    var v = (cents / 100).toFixed(2);
    return f.replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents/100));
  }

  /* A card has nowhere to put an error, and a click that does nothing is worse
     than a refusal, so failures get said out loud here. */
  var toastEl;
  function say(msg){
    if(!toastEl){
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('on');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function(){ toastEl.classList.remove('on'); }, 4000);
  }

  /* ---------- basket ---------- */
  var bag      = document.getElementById('bag'),
      bagScrim = document.getElementById('bagScrim'),
      bagBtn   = document.getElementById('bagBtn'),
      bagX     = document.getElementById('bagX'),
      bagCount = document.getElementById('bagCount'),
      bagLines = document.getElementById('bagLines');

  function openBag(on){
    if(!bag) return;
    bag.classList.toggle('on', on);
    bag.setAttribute('aria-hidden', on ? 'false' : 'true');
    if(bagScrim) bagScrim.classList.toggle('on', on);
    document.body.style.overflow = on ? 'hidden' : '';
  }
  if(bagBtn)   bagBtn.addEventListener('click', function(){ openBag(!bag.classList.contains('on')); });
  if(bagX)     bagX.addEventListener('click', function(){ openBag(false); });
  if(bagScrim) bagScrim.addEventListener('click', function(){ openBag(false); });

  /* The drawer markup is Liquid, so it is fetched rendered rather than built
     here. That keeps one source of truth for how a line looks. */
  function refreshBag(){
    return fetch(window.location.pathname + '?section_id=cart-drawer', { headers:{ 'Accept':'text/html' } })
      .then(function(r){ return r.ok ? r.text() : null; })
      .then(function(html){
        if(html){
          var d = document.createElement('div'); d.innerHTML = html;
          var fresh = d.querySelector('[data-cart-lines]');
          if(fresh){
            /* the drawer and the cart page are two views of one cart, so both
               are rewritten; only refreshing the drawer made a removal on
               /cart look like a click that did nothing. */
            [].forEach.call(document.querySelectorAll('[data-cart-lines], #bagLines'), function(el){
              el.innerHTML = fresh.innerHTML;
            });
          }
        }
        return fetch(R.cart + '.js', { headers:{ 'Accept':'application/json' } });
      })
      .then(function(r){ return r && r.json ? r.json() : null; })
      .then(function(cart){
        if(cart && bagCount){
          bagCount.textContent = cart.item_count;
          bagCount.style.display = cart.item_count ? '' : 'none';
        }
      })
      .catch(function(){});
  }

  window.CC = {
    add: function(variantId, qty){
      return fetch(R.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
      })
      .then(function(r){ return r.json().then(function(b){ return { ok:r.ok, body:b }; }); })
      .then(function(res){
        if(!res.ok) return { ok:false, message: res.body.description || res.body.message };
        return refreshBag().then(function(){ openBag(true); return { ok:true }; });
      })
      .catch(function(){
        /* a dropped connection must not look like a click that did nothing */
        return { ok:false, message:'Could not reach the shop. Check your connection and try again.' };
      });
    },
    change: function(key, qty){
      return fetch(R.cartChange, {
        method: 'POST',
        headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(refreshBag).catch(function(){ say('Could not update the basket. Try again.'); });
    }
  };

  document.addEventListener('click', function(e){
    var rm = e.target.closest && e.target.closest('.bagRm');
    if(rm){ e.preventDefault(); window.CC.change(rm.dataset.key, 0); }
  });

  /* add straight from a card, since most pieces exist in one size */
  document.addEventListener('click', function(e){
    var chip = e.target.closest && e.target.closest('.sizes span[data-id]');
    if(!chip || chip.classList.contains('out')) return;
    e.preventDefault(); e.stopPropagation();
    window.CC.add(chip.dataset.id, 1).then(function(res){
      if(res && !res.ok) say(res.message || 'That one has just gone.');
    });
  });

  /* ---------- product form ---------- */
  var picks = document.getElementById('picks'),
      pVar  = document.getElementById('pVariant'),
      warn  = document.getElementById('warn'),
      pForm = document.getElementById('pForm');

  if(picks){
    picks.addEventListener('click', function(e){
      var b = e.target.closest('.pick');
      if(!b || b.disabled) return;
      [].forEach.call(picks.children, function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      if(pVar) pVar.value = b.dataset.id;
      if(warn) warn.textContent = '';
    });
  }

  if(pForm){
    pForm.addEventListener('submit', function(e){
      e.preventDefault();
      if(!pVar || !pVar.value){ if(warn) warn.textContent = 'Pick a size first.'; return; }
      window.CC.add(pVar.value, 1).then(function(res){
        if(res && !res.ok && warn) warn.textContent = res.message || 'That one is not available.';
      });
    });
  }

  /* ---------- tables on a phone ----------
     The privacy and delivery pages carry three-column tables. At 390px those
     either squash to unreadable or push the page sideways, so each one gets a
     scroller of its own rather than dragging the layout with it. */
  [].forEach.call(document.querySelectorAll('.docBody table, .rte table'), function(t){
    if(t.parentElement.classList.contains('tableScroll')) return;
    var w = document.createElement('div');
    w.className = 'tableScroll';
    t.parentNode.insertBefore(w, t);
    w.appendChild(t);
  });

  /* ---------- hero film ----------
     The section puts both encodes on the element as data attributes rather than
     a src, so the phone never starts downloading the 7.9MB desktop cut. This
     picks one, and honours a reduced-motion preference by leaving the poster. */
  var films = document.querySelectorAll('[data-hero]');
  if(films.length && !matchMedia('(prefers-reduced-motion: reduce)').matches){
    var small = matchMedia('(max-width: 900px)').matches;
    [].forEach.call(films, function(film){
      film.src = small ? film.dataset.mobile : film.dataset.desktop;
      film.addEventListener('canplay', function(){
        film.classList.add('live');
        film.play().catch(function(){});
      });
      film.load();
    });
    /* if the browser refuses scripted autoplay, the first interaction starts it */
    var kick = function(){
      [].forEach.call(films, function(f){ if(f.paused) f.play().catch(function(){}); });
    };
    document.addEventListener('touchstart', kick, { once:true, passive:true });
    document.addEventListener('pointerdown', kick, { once:true });
    document.addEventListener('scroll', kick, { once:true, passive:true });
  }

  /* ---------- gallery ---------- */
  var gImg = document.getElementById('gImg'), thumbs = document.getElementById('gThumbs');
  if(thumbs){
    thumbs.addEventListener('click', function(e){
      var b = e.target.closest('button'); if(!b) return;
      gImg.src = b.dataset.src;
      [].forEach.call(thumbs.children, function(x){ x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
    });
  }
  /* ---------- the sideways rails ----------
     A rail that scrolls sideways needs to look like it does. The bar fills as
     you move through it and hides itself when everything already fits. */
  [].forEach.call(document.querySelectorAll('[data-rail]'), function(rail){
    var bar = rail.parentNode.querySelector('[data-rail-bar]');
    if(!bar) return;
    var thumb = bar.querySelector('.railThumb');

    function sync(){
      var span = rail.scrollWidth - rail.clientWidth;
      if(span < 12){ bar.classList.add('gone'); return; }
      bar.classList.remove('gone');
      var seen = rail.clientWidth / rail.scrollWidth;
      thumb.style.width = Math.max(seen * 100, 12) + '%';
      thumb.style.transform = 'translateX(' + (rail.scrollLeft / span) *
        ((bar.clientWidth - thumb.offsetWidth)) + 'px)';
      if(rail.scrollLeft > 8) bar.classList.add('moved');
    }

    sync();
    rail.addEventListener('scroll', function(){
      if(rail._t) return;
      rail._t = requestAnimationFrame(function(){ rail._t = null; sync(); });
    }, { passive:true });
    addEventListener('resize', sync);
    if(window.ResizeObserver) new ResizeObserver(sync).observe(rail);
  });

  /* ---------- grade tiles ----------
     Moving across a grade shows what it means beside the tiles. Focus counts as
     well as hover, so it works from the keyboard, and on touch the wording is
     printed inside each tile instead. */
  var gNote = document.getElementById('gNote');
  if(gNote){
    var gT = document.getElementById('gNoteTitle'),
        gB = document.getElementById('gNoteBody'),
        gM = document.getElementById('gNoteMore');
    var first = { t: gT.textContent, b: gB.textContent, m: gM ? gM.textContent : '' };
    [].forEach.call(document.querySelectorAll('.gTile'), function(t){
      function show(){
        gT.textContent = t.dataset.grade || '';
        gB.textContent = t.dataset.note || '';
        if(gM) gM.textContent = t.dataset.detail || '';
        gNote.classList.add('lit');
      }
      t.addEventListener('mouseenter', show);
      t.addEventListener('focus', show);
    });
    var tiles = document.querySelector('.gTiles');
    if(tiles) tiles.addEventListener('mouseleave', function(){
      gT.textContent = first.t; gB.textContent = first.b;
      if(gM) gM.textContent = first.m;
      gNote.classList.remove('lit');
    });
  }

  /* ---------- sort ---------- */
  var sortBy = document.getElementById('sortBy');
  if(sortBy) sortBy.addEventListener('change', function(){ document.getElementById('sortForm').submit(); });
  var openFilters = document.getElementById('openFilters'), filterForm = document.getElementById('filterForm');
  if(openFilters && filterForm){
    openFilters.addEventListener('click', function(){
      var on = filterForm.classList.toggle('on');
      openFilters.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
  }

  var sheet  = document.getElementById('sheet'),
      burger = document.getElementById('burger'),
      scrim  = document.getElementById('scrim'),
      hdr    = document.querySelector('header');

  if(sheet && burger){
    /* the panel hangs off the live header, which changes height as the
       announcement bar scrolls away, so it is measured on every open */
    function seat(){
      var b = hdr ? hdr.getBoundingClientRect().bottom : 60;
      if(b < 0) b = 0;
      sheet.style.top = b + 'px';
      sheet.style.maxHeight = 'calc(100vh - ' + b + 'px - 12px)';
    }
    function setSheet(on){
      if(on) seat();
      sheet.classList.toggle('on', on);
      if(scrim) scrim.classList.toggle('on', on);
      burger.classList.toggle('on', on);
      burger.setAttribute('aria-expanded', on ? 'true' : 'false');
      document.body.style.overflow = on ? 'hidden' : '';
    }
    burger.addEventListener('click', function(){ setSheet(!sheet.classList.contains('on')); });
    if(scrim) scrim.addEventListener('click', function(){ setSheet(false); });
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && sheet.classList.contains('on')) setSheet(false);
    });
    [].forEach.call(sheet.querySelectorAll('a'), function(a){
      a.addEventListener('click', function(){ setSheet(false); });
    });
    addEventListener('resize', function(){
      if(sheet.classList.contains('on')) seat();
    });
  }

  /* The newsletter is a real {% form 'customer' %}. It posts natively and the
     footer renders Shopify's own success and error states, so there is nothing
     for JavaScript to do here. A handler that preventDefault()s would throw the
     address away. */

  /* ---------- search ----------
     Suggestions come from Shopify's Predictive Search API. The previous version
     filtered a variable called ALL, which belonged to the flat build and does
     not exist here, so it threw on every keystroke on every page and the panel
     never updated. Enter still submits to /search either way. */
  var sWrap = document.getElementById('searchWrap'),
      sIn   = document.getElementById('searchInput'),
      sOut  = document.getElementById('searchOut'),
      sBtn  = document.getElementById('searchBtn'),
      sX    = document.getElementById('searchX'),
      sTimer, sLast;

  function openSearch(on){
    if(!sWrap) return;
    sWrap.classList.toggle('on', on);
    document.body.style.overflow = on ? 'hidden' : '';
    if(on && sIn) setTimeout(function(){ sIn.focus(); }, 60);
  }
  if(sBtn) sBtn.addEventListener('click', function(){ openSearch(true); });
  if(sX)   sX.addEventListener('click', function(){ openSearch(false); });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && sWrap && sWrap.classList.contains('on')) openSearch(false);
  });

  if(sIn && sOut){
    sIn.addEventListener('input', function(){
      var q = sIn.value.trim();
      clearTimeout(sTimer);
      if(q.length < 2){ sOut.innerHTML = ''; return; }
      sTimer = setTimeout(function(){
        sLast = q;
        var url = (R.predictive || '/search/suggest') +
                  '?q=' + encodeURIComponent(q) +
                  '&resources[type]=product&resources[limit]=6';
        fetch(url, { headers:{ 'Accept':'application/json' } })
          .then(function(r){ return r.ok ? r.json() : null; })
          .then(function(d){
            if(sLast !== q) return;               /* a later keystroke won */
            var items = d && d.resources && d.resources.results && d.resources.results.products;
            if(!items || !items.length){
              sOut.innerHTML = '<p class="sHint">Nothing matching that.</p>'; return;
            }
            sOut.innerHTML = items.map(function(p){
              var img = p.featured_image && p.featured_image.url
                ? '<img src="' + p.featured_image.url + '" alt="" loading="lazy">' : '';
              return '<a href="' + p.url + '">' + img +
                     '<span>' + p.title + '</span>' +
                     '<em>' + money(p.price) + '</em></a>';
            }).join('');
          })
          .catch(function(){
            sOut.innerHTML = '<p class="sHint">Search is having a moment. Press enter to search the shop.</p>';
          });
      }, 220);
    });
  }

  /* ---------- the wordmark on a phone ----------
     There is no hover on touch, and a tap follows the link instantly, so the
     cloth-to-white change would never be seen. Touching lights it straight away
     and the link is held for a beat so the change actually registers. */
  if(matchMedia('(hover: none)').matches){
    /* the two cloth tiles inside the menu light on touch as well */
    [].forEach.call(document.querySelectorAll('.sSide'), function(el){
      el.addEventListener('touchstart', function(){ el.classList.add('touched'); }, { passive:true });
    });

    var halves = document.querySelectorAll('.mHalf');
    [].forEach.call(halves, function(el){
      el.addEventListener('touchstart', function(){
        [].forEach.call(halves, function(o){ o.classList.remove('touched'); });
        el.classList.add('touched');
      }, { passive:true });

      el.addEventListener('click', function(ev){
        if(el.dataset.go === '1') return;          // second tap goes through
        ev.preventDefault();
        el.classList.add('touched');
        el.dataset.go = '1';
        setTimeout(function(){ location.href = el.getAttribute('href'); }, 260);
      });
    });

    /* touching anywhere else puts them back into their cloth */
    document.addEventListener('touchstart', function(e){
      if(e.target.closest('.mHalf')) return;
      [].forEach.call(halves, function(o){ o.classList.remove('touched'); });
    }, { passive:true });
  }

  /* ---------- reveals ---------- */
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { rootMargin:'0px 0px -10% 0px' });
  [].forEach.call(document.querySelectorAll('.up,.stamp'), function(el){ io.observe(el); });

  /* content must never be able to hide permanently: anything the observer has
     not revealed within a beat of being on screen gets revealed by hand */
  function sweepReveal(){
    var vh = window.innerHeight;
    [].forEach.call(document.querySelectorAll('.up:not(.in),.stamp:not(.in)'), function(el){
      var r = el.getBoundingClientRect();
      if(r.top < vh && r.bottom > 0) el.classList.add('in');
    });
  }
  setTimeout(sweepReveal, 900);
  window.addEventListener('scroll', function(){ setTimeout(sweepReveal, 350); }, { passive:true });
})();
